import { directPurchaseCredentials } from './credentials.js';
/** Fresh customer credentials authorize each server route recheck, never a stored intent. */
export function directPurchaseIntentClient(client, provider) {
    const credentials = (signal) => directPurchaseCredentials(provider, signal ?? new AbortController().signal);
    return {
        ...client,
        async createOperation(...[input, signal]) {
            return client.createOperation(input, signal, await credentials(signal));
        },
        async prepareAttempt(...[id, signature, expiresAt, sessionProofId, signal, amounts, cardId]) {
            return client.prepareAttempt(id, signature, expiresAt, sessionProofId, signal, amounts, cardId, await credentials(signal));
        },
        async refreshAttemptQuote(...[id, attemptId, signature, expiresAt, sessionProofId, signal, amounts, units]) {
            return client.refreshAttemptQuote(id, attemptId, signature, expiresAt, sessionProofId, signal, amounts, units, await credentials(signal));
        },
    };
}
